import React, { Component } from 'react';
import { CHANNEL, CHANNEL_DP, COMMON_IMG } from '../constants';
import {
  Chip,
  Grid,
  // Select,
  // MenuItem,
  withStyles,
  withWidth,
  Typography,
} from '@material-ui/core';

const styles = (theme) => ({});

const colors = [
  '#f2e0df',
  '#dff0f5',
  '#dce7c3',
  '#dcdcdc',
  '#e4dfec',
  '#b1ccc2',
  '#ddd9c4',
  '#fbdfa7',
  '#edd1b5',
  '#edd1b5',
  '#edd1b5',
  '#edd1b5',
  '#dcdcdc',
  '#f2e0df',
  '#dff0f5',
  '#dce7c3',
  '#dcdcdc',
];
const category = [
  'Coronary-Master Theater',
  'Vascular-Pioneer Theater',
  'SHD Lecture',
  'Satellite Symposium',
  'Nurse & Technologist',
  'Case and Abstract',
  'Morning Session',
  'Scientific Session',
  'Joint Session',
  'Expert Meeting',
  "Young Doctor's Session I (Korean)",
  "Young Doctor's Session II (Korean)",
  'Dinner Symposium',
  'Coronary Lecture',
  'Vascular Lecture',
  'Concurrent Session',
  'Training Center',
];

class Scheduler extends Component {
  mediaQuery = null;
  constructor(props) {
    super(props);
    const agent = navigator.userAgent.toLocaleLowerCase();
    this.state = {
      isIE: agent.indexOf('msie') !== -1 || agent.indexOf('rv:11.0') !== -1 ? true : false,
      matches: window.matchMedia('(max-width: 600px)').matches,
      selectedChannel: CHANNEL[0],
      isDay3: false,

      // 일자별 시작 시간
      startHour: this.props.selectIdx === 0 ? 8 : 8,
    };
  }

  setMedia = (param) => {
    this.setState({ matches: param.matches });
  };

  componentDidMount() {
    this.mediaQuery = window.matchMedia('(max-width:600px)');
    this.mediaQuery.addListener(this.setMedia);
  }

  componentWillUnmount() {
    this.mediaQuery.removeListener(this.setMedia);
  }

  getColor = (idx) => {
    // let cIdx = idx % colors.length;
    return colors[category.indexOf(idx)];
  };

  padStart = (data, targetLength, padString) => {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (data.length > targetLength) {
      return String(data);
    } else {
      targetLength = targetLength - data.length;
      // if (targetLength > padString.length) {
      //   padString += padString.repeat(targetLength / padString.length);
      // }
      return padString.slice(0, targetLength) + String(data);
    }
  };

  //일반 그리드 생성
  getScheduleStyle = () => {
    let strRow = '[tracks] 50px ';
    for (let i = this.state.startHour; i < this.props.endHour; i++) {
      for (let j = 0; j < 60; j += 10) {
        let h = String(i);
        let m = String(j);
        // **custom 세션별 그리드 가로 크기 조절
        // strRow += '[ T' + this.padStart(h, 2, '0') + this.padStart(m, 2, '0') + '] 15px ';
        strRow += '[ T' + this.padStart(h, 2, '0') + this.padStart(m, 2, '0') + '] 20px ';
      }
    }
    let strCol = '[times] 4em [';
    // eslint-disable-next-line
    CHANNEL.map((data, i) => {
      strCol += data + '-start] 1fr [' + data + '-end ';
    });
    strCol += ']';

    let rtnStyle = {
      display: 'grid',
      gridTemplateRows: strRow,
      gridTemplateColumns: strCol,
      width: '100%',
      border: '1px solid #cccccc',
    };
    return rtnStyle;
  };

  //모바일 그리드 생성
  getScheduleStyleMB = () => {
    let strRow = '[tracks] 0px ';
    for (let i = this.state.startHour; i < this.props.endHour; i++) {
      for (let j = 0; j < 60; j += 10) {
        let h = String(i);
        let m = String(j);
        strRow += '[ T' + this.padStart(h, 2, '0') + this.padStart(m, 2, '0') + '] auto ';
      }
    }
    let strCol = '[times] 4em [';

    strCol += this.state.selectedChannel + '-start] 1fr [' + this.state.selectedChannel + '-end ';

    strCol += ']';

    let rtnStyle = {
      // display: 'grid',
      gridTemplateRows: strRow,
      gridTemplateColumns: strCol,
      width: '100%',
    };
    if (this.props.width === 'xs' || this.props.width === 'sm') rtnStyle['border'] = '1px solid #ccc';
    return rtnStyle;
  };

  //ie 그리드 생성
  getScheduleStyleIE = () => {
    let strRow = '30px ';
    for (let i = this.state.startHour; i < this.props.endHour; i++) {
      for (let j = 0; j < 60; j += 10) {
        strRow += 'auto ';
      }
    }

    let strCol = '4em ';
    // eslint-disable-next-line
    CHANNEL.map((data, i) => {
      strCol += '1fr ';
    });
    strCol += '';

    const rtnStyle = {
      display: '-ms-grid',
      msGridRows: strRow,
      msGridColumns: strCol,
      width: '100%',
      border: '1px solid #cccccc',
    };
    return rtnStyle;
  };

  getRowSpan = (stTime, edTime) => {
    return this.getRowIdx(edTime) - this.getRowIdx(stTime);
  };

  getRowIdx = (time) => {
    let buff = time.split(':');
    let nT = Number.parseInt(buff[0]);
    let sT = Number.parseInt('' + this.state.startHour);
    let mT = Number.parseInt(buff[1]);

    if (mT === 0) {
      return (nT - sT) * 6 + 2;
    } else {
      return (nT - sT) * 6 + parseInt(mT / 10) + 2;
    }
  };

  getColIdx = (ch) => {
    let idx = -1;
    for (let i = 0; i < CHANNEL.length; i++) {
      if (CHANNEL[i] === ch) {
        idx = i;
      }
    }
    return idx + 2;
  };
  // console.log('match')
  render() {
    return this.state.matches ? (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* <Select
          style={{
            border: '1px solid #cccccc',
            margin: '0px 10px 10px 10px',
            width: '100%',
            height: '40px',
            padding: '10px',
            textAlign: 'center',
          }}
          value={this.state.selectedChannel}
          onChange={(event, value) => {
            // console.log(event);
            // console.log(value);
            this.setState({ selectedChannel: value.props.value });
          }}
        >
          {CHANNEL.map((data, i) => {
            return (
              <MenuItem key={i} value={CHANNEL[i]}>
                {CHANNEL_DP[i]}
              </MenuItem>
            );
          })}
        </Select> */}

        <Grid container justifyContent="center" item xs={11}>
          {CHANNEL.map((data, i) => {
            return (
              <Grid container justifyContent="center" item xs={4}>
                <Chip
                  key={i}
                  label={`Ch ${i + 1}`}
                  style={{
                    fontWeight: 'bold',
                    // fontSize: 'large',
                    padding: '10px 10px',
                    // marginRight: 10,
                    marginBottom: '10px',
                    // paddingRight: 5.5,
                    // paddingLeft: 5.5,
                    backgroundColor: this.state.selectedChannel === `Channel0${i + 1}` ? this.props.theme.palette.primary.main : '#efefef',
                    color: this.state.selectedChannel === `Channel0${i + 1}` ? 'white' : '#333',
                  }}
                  onClick={() => {
                    this.setState({ selectedChannel: `Channel0${i + 1}` });
                  }}
                />
              </Grid>
            );
          })}
        </Grid>

        <div style={this.getScheduleStyleMB()}>
          {/* 그리드 좌측 상단 첫번째 헤더 내용 */}
          <div style={{ gridRow: 'tracks', gridColumn: 'times', textAlign: 'center', fontSize: '12px' }} />

          {/* 좌측 시간 리스트 */}
          {/* {Array.apply(0, Array(this.props.endHour - this.state.startHour)).map((value, i) => {
            let h = String(this.state.startHour + i);
            let n = String(this.state.startHour + i + 1);
            let t = 'T' + this.padStart(h, 2, '0') + '00 / T' + this.padStart(n, 2, '0') + '00';
            return (
              <div key={i} style={{ gridRow: t, gridColumn: 'times', textAlign: 'center', fontSize: '12px' }}>{`${this.padStart(
                h,
                2,
                '0',
              )}:00`}</div>
            );
          })} */}

          {/* 데이터 기본 */}

          <div
            style={{
              gridRow: `tracks / T${this.padStart(String(this.props.endHour), 2, '0')}00`,
              gridColumn: this.state.selectedChannel,
              borderLeft: '1px solid #cccccc',
            }}
          />

          {/* 데이터 */}
          {this.props.data
            .filter((m) => m.channel === this.state.selectedChannel)
            .map((data, i) => {
              let startT = data.startTime.replace(':', '');
              startT = startT.substring(0, startT.length - 1) + '0';
              let endT = data.endTime.replace(':', '');
              endT = endT.substring(0, endT.length - 1) + '0';

              const isDP = true;
              // console.log(startT, '12321321312');
              // if (data.isBreak) {
              if (!isDP) {
                return null;
              } else {
                return (
                  <div
                    key={i}
                    style={{
                      gridRow: `T${startT} / T${endT}`,
                      gridColumn: `${data.channel}`,
                      background: data.isBreak && data.pgTitle === 'Break Time' ? '#ebebeb' : `${data.pgStyle}`,
                      // background: this.getColor(data.category),
                      wordBreak: 'keep-all',
                      padding: '5px',
                      textAlign: 'center',
                      // fontSize: '12px',
                      fontSize: '14px',
                      // display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      // margin: '2px 2px 2px 3px',
                      borderTop: '1px solid #cccccc',
                      borderBottom: '1px solid #cccccc',

                      //   backgroundColor: '#FCD5B4',
                      cursor: 'Pointer',
                    }}
                    onClick={(e) => {
                      this.props.clickDetail(e, data);
                    }}
                  >
                    <div>
                      {/* **KSIC2022 CUSTOM: 모바일 시작시간 표시 */}
                      {data && data.pgTitle !== 'Break' && (
                        <Grid container justifyContent="center">
                          <Typography style={{ fontSize: '13px', color: '#3f4058', fontWeight: 'bold' }}>
                            {data.startTime}&nbsp;~&nbsp;{data.endTime}
                          </Typography>
                        </Grid>
                      )}

                      {data && data.id === 'pgm_1639969490244' ? (
                        //KSIC 2022 CUsTOM: 7일 오프닝 행사 시간 표기
                        <div>
                          KSIC 2022 Opening Remark
                          {/* <br />
                          08:50~09:00 */}
                        </div>
                      ) : (
                        <>
                          <div>
                            {data.isEng && (
                              <Chip
                                size="small"
                                label="ENG"
                                style={{ backgroundColor: '#164578', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                              />
                            )}

                            {/* {!data.isBreak && !data.isEng && (
                              <Chip
                                size="small"
                                label="KOR"
                                style={{ backgroundColor: 'rgb(220, 0, 78)', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                              />
                            )}
                            {data && data.id === 'pgm_1639563317220' && (
                              <Chip
                                size="small"
                                label="KOR"
                                style={{ backgroundColor: 'rgb(220, 0, 78)', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                              />
                            )} */}
                          </div>

                          <Grid container justifyContent="center">
                            <Grid container justifyContent="center" item xs={11}>
                              {data.pgTitle && data.pgTitle === 'Break' ? (
                                // **KSIC2022 CUSTOM: break 별 표기 반영
                                <div>
                                  {data.id === 'pgm_1641385155907' || data.id === 'pgm_1640916696732' || data.id === 'pgm_1640916755276' ? (
                                    <div style={{ fontWeight: 700 }}>Break(30 Min) </div>
                                  ) : (
                                    <div style={{ fontWeight: 700 }}>Break(10 Min) </div>
                                  )}
                                </div>
                              ) : (
                                <div style={{ fontWeight: 700 }} dangerouslySetInnerHTML={{ __html: data.title }} />
                              )}
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {data.isLive ? (
                        <img
                          src={`${COMMON_IMG}/live.gif`}
                          style={{
                            width: '50px',
                            height: 'auto',
                            verticalAlign: 'middle',
                            marginLeft: '5px',
                            cursor: 'Pointer',
                          }}
                          onClick={(e) => {
                            this.props.clickProgram(e, data.channel);
                          }}
                          alt={'live-icon'}
                        />
                      ) : null}

                      {data.vod ? (
                        <Chip
                          size="small"
                          label="VOD"
                          style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                          onClick={(e) => {
                            this.props.clickDetail(e, data);
                          }}
                          // onClick={(e) => {
                          //   this.props.clickVOD(e, data.vod, data);
                          // }}
                        />
                      ) : null}

                      {/* **KSIC2022 CUSTOM: 모바일 종료시간 표시 */}

                      {/* {data && data.pgTitle !== 'Break' && (
                        <Grid container justifyContent="flex-start">
                          <Typography style={{ fontSize: '12px', color: '#3f4058' }}>{data.endTime}</Typography>
                        </Grid>
                      )} */}
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </div>
    ) : (
      <div style={{ width: '100%' }}>
        <div style={this.state.isIE ? this.getScheduleStyleIE() : this.getScheduleStyle()}>
          {/* 그리드 좌측 상단 첫번째 헤더 내용 */}
          {this.state.isIE ? (
            <div style={{ msGridRow: 1, msGridColumn: 1, borderBottom: '1px solid #ccc', backgroundColor: '#DEE7EB' }} />
          ) : (
            <div
              style={{
                gridRow: 'tracks',
                gridColumn: 'times',
                textAlign: 'center',
                // fontSize: '12px',
                fontSize: '14px',
                fontWeight: 'bold',
                borderBottom: '1px solid #ccc',
                backgroundColor: '#DEE7EB',
                // backgroundColor: '#FCD5B4',
              }}
            >
              TIME
              <br />
              (KST)
            </div>
          )}
          {/* 그리드 좌측 두번째 부터 끝까지 헤더 내용 */}
          {this.state.isIE
            ? Array.apply(0, Array(CHANNEL_DP.length)).map((value, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      msGridRow: 1,
                      msGridColumn: i + 2,
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      //   fontSize: '12px',
                      fontSize: '14px',
                      borderBottom: '1px solid #ccc',
                      backgroundColor: '#DEE7EB',
                    }}
                  >
                    <span>{CHANNEL_DP[i]}</span>
                  </div>
                );
              })
            : Array.apply(0, Array(CHANNEL_DP.length)).map((value, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      gridRow: 'tracks',
                      gridColumn: CHANNEL[i],
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      //   fontSize: '12px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      borderBottom: '1px solid #ccc',
                      backgroundColor: '#DEE7EB',
                    }}
                  >
                    <span>{CHANNEL_DP[i]}</span>
                  </div>
                );
              })}
          {/* 좌측 시간 리스트 */}
          {this.state.isIE
            ? Array.apply(0, Array(this.props.endHour - this.state.startHour)).map((value, i) => {
                let h = String(this.state.startHour + i);
                return (
                  <div
                    key={i}
                    style={{
                      msGridRow: i * 6 + 2,
                      msGridColumn: 1,
                      textAlign: 'center',
                      // fontSize: '12px'
                      fontSize: '14px',
                    }}
                  >{`${this.padStart(h, 2, '0')}:00`}</div>
                );
              })
            : Array.apply(0, Array(this.props.endHour - this.state.startHour)).map((value, i) => {
                let h = String(this.state.startHour + i);
                let n = String(this.state.startHour + i + 1);
                let t = 'T' + this.padStart(h, 2, '0') + '00 / T' + this.padStart(n, 2, '0') + '00';
                return (
                  <div
                    key={i}
                    style={{ gridRow: t, gridColumn: 'times', textAlign: 'center', fontSize: '12px', backgroundColor: '' }}
                  >{`${this.padStart(h, 2, '0')}:00`}</div>
                );
              })}
          {/* 데이터 기본 */}
          {this.state.isIE
            ? Array.apply(0, Array(CHANNEL.length)).map((value, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      msGridRow: 1,
                      msGridColumn: i + 2,
                      msGridRowSpan: (this.props.endHour - this.state.startHour) * 60 + 1,
                      borderLeft: '1px solid #cccccc',
                    }}
                  />
                );
              })
            : Array.apply(0, Array(CHANNEL.length)).map((value, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      gridRow: `tracks / T${this.padStart(String(this.props.endHour), 2, '0')}00`,
                      gridColumn: `${CHANNEL[i]}`,
                      borderLeft: '1px solid #cccccc',
                    }}
                  />
                );
              })}
          {/* 데이터 */}
          {this.state.isIE
            ? this.props.data.map((data, i) => {
                const isDP = true;
                if (!isDP) {
                  return null;
                } else {
                  return (
                    <div
                      key={i}
                      style={{
                        msGridRow: this.getRowIdx(data.startTime),
                        msGridColumn: this.getColIdx(data.channel),
                        msGridRowSpan: this.getRowSpan(data.startTime, data.endTime),
                        // background: this.getColor(data.category),
                        background: data.isBreak && data.pgTitle === 'Break Time' ? '#ebebeb' : `${data.pgStyle}`,
                        wordBreak: 'keep-all',
                        padding: '5px',
                        textAlign: 'center',
                        fontSize: '12px',
                        // margin: '2px 2px 2px 3px',
                        // borderTop: i === 0 && '1px solid #cccccc',
                        borderTop: '1px solid #cccccc',
                        borderBottom: '1px solid #cccccc',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'Pointer',
                      }}
                      onClick={(e) => {
                        this.props.clickDetail(e, data);
                      }}
                    >
                      <div>
                        <Grid container item xs={12} style={{ height: '100%' }}>
                          <Grid container>
                            <Grid item xs={4}>
                              {data.isEng && (
                                <Chip
                                  size="small"
                                  label="Eng"
                                  style={{ backgroundColor: '#164578', color: '#fff', fontSize: '0.8em', textTransform: 'none' }}
                                />
                              )}
                            </Grid>
                            <Grid item xs={4}>
                              {data.isLive ? (
                                <img
                                  src={`${COMMON_IMG}/live.gif`}
                                  style={{
                                    width: '50px',
                                    height: 'auto',
                                    verticalAlign: 'middle',
                                    marginLeft: '5px',
                                    cursor: 'Pointer',
                                  }}
                                  onClick={(e) => {
                                    this.props.clickProgram(e, data.channel);
                                  }}
                                  alt={'live-icon'}
                                />
                              ) : null}
                            </Grid>

                            <Grid item xs={4}>
                              {/* 다시보기 */}
                              {data.vod ? (
                                <Chip
                                  size="small"
                                  label="VOD"
                                  style={{ backgroundColor: '#9ccc65', color: '#fff', fontSize: '0.8em' }}
                                  // onClick={(e) => {
                                  //   this.props.clickVOD(e, data.vod, data);
                                  // }}
                                  onClick={(e) => {
                                    this.props.clickDetail(e, data);
                                  }}
                                />
                              ) : null}
                            </Grid>
                          </Grid>
                        </Grid>

                        <div dangerouslySetInnerHTML={{ __html: data.title.replace(/\(/g, '<br/>(') }} />

                        {/* <div style={{ display: 'flex' }}>
                          {data.isEng && (
                            <Chip
                              size="small"
                              label="ENG"
                              style={{ backgroundColor: '#164578', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                            />
                          )}

                          {!data.isBreak && !data.isEng && (
                            <Chip
                              size="small"
                              label="KOR"
                              style={{ backgroundColor: 'rgb(220, 0, 78)', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                            />
                          )}

                          {data && data.id === 'pgm_1639563317220' && (
                            <Chip
                              size="small"
                              label="KOR"
                              style={{ backgroundColor: 'rgb(220, 0, 78)', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                            />
                          )}
                        </div>

                        <div dangerouslySetInnerHTML={{ __html: data.title.replace(/\(/g, '<br/>(') }} />
                        {data.isLive ? (
                          <img
                            src={`${COMMON_IMG}/live.gif`}
                            style={{
                              width: '50px',
                              height: 'auto',
                              verticalAlign: 'middle',
                              marginLeft: '5px',
                              cursor: 'Pointer',
                            }}
                            onClick={(e) => {
                              this.props.clickProgram(e, data.channel);
                            }}
                            alt={'live-icon'}
                          />
                        ) : null}
                        {data.vod ? (
                          <Chip
                            size="small"
                            label="VOD"
                            style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                            onClick={(e) => {
                              this.props.clickVOD(e, data.vod, data);
                            }}
                          />
                        ) : null} */}
                      </div>
                    </div>
                  );
                }
              })
            : this.props.data.map((data, i) => {
                let startT = data.startTime.replace(':', '');
                startT = startT.substring(0, startT.length - 1) + '0';
                let endT = data.endTime.replace(':', '');
                endT = endT.substring(0, endT.length - 1) + '0';
                const isDP = true; //!data.isBreak || startT === '1300';
                if (!isDP) {
                  return null;
                } else {
                  //   const st = ['0850', '0800', '0800', '0800'];
                  //     const breakShow = ['1300', '1230', '1230'];
                  //   const isFirstRow = this.props.selectIdx !== 0 && st[this.props.selectIdx] === startT;
                  let tit = data.isBreak && data.pgTitle === 'Break' ? '' : data.title.replace(/\(/g, '<br/>(');
                  // if (breakShow[this.props.selectIdx] === startT) tit = 'Break';
                  return (
                    <div
                      key={i}
                      style={{
                        gridRow: `T${startT} / T${endT}`,
                        gridColumn: `${data.channel}`,
                        background: data.isBreak && data.pgTitle === 'Break Time' ? '#ebebeb' : `${data.pgStyle}`,
                        wordBreak: 'keep-all',
                        padding: '5px',
                        textAlign: 'center',
                        // fontSize: '12px',
                        fontSize: data.id === 'evt113_143' || data.id === 'evt113_144' ? '12.5px' : '14px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        // borderTop: isFirstRow && '1px solid #cccccc',
                        // margin: '2px 2px 2px 3px',
                        borderTop: '1px solid #cccccc',
                        borderBottom: '1px solid #cccccc',
                        cursor: 'Pointer',
                      }}
                      onClick={(e) => {
                        this.props.clickDetail(e, data);
                      }}
                    >
                      <div style={{ width: '100%' }}>
                        {/* {data.isEng && (
                          <Chip size="small" label="ENG" style={{ backgroundColor: '#164578', color: '#fff', fontSize: '0.8em' }} />
                        )} */}

                        {/* {!data.isBreak && !data.isEng && (
                          <Chip
                            size="small"
                            label="KOR"
                            style={{ backgroundColor: 'rgb(220, 0, 78)', color: 'white', fontSize: '1em', marginLeft: '5px' }}
                          />
                        )} */}
                        <Grid container item xs={12} style={{ height: '100%' }}>
                          <Grid container>
                            <Grid item xs={4}>
                              {data.isEng && (
                                <Chip
                                  size="small"
                                  label="Eng"
                                  style={{ textTransform: 'none', backgroundColor: '#164578', color: '#fff', fontSize: '0.8em' }}
                                />
                              )}
                            </Grid>
                            <Grid item xs={4}>
                              {data.isLive ? (
                                <img
                                  src={`${COMMON_IMG}/live.gif`}
                                  style={{
                                    width: '50px',
                                    height: 'auto',
                                    verticalAlign: 'middle',
                                    marginLeft: '5px',
                                    cursor: 'Pointer',
                                  }}
                                  onClick={(e) => {
                                    this.props.clickProgram(e, data.channel);
                                  }}
                                  alt={'live-icon'}
                                />
                              ) : null}
                            </Grid>

                            <Grid item xs={4}>
                              {/* 다시보기 */}
                              {data.vod ? (
                                <Chip
                                  size="small"
                                  label="VOD"
                                  style={{ backgroundColor: '#9ccc65', color: '#fff', fontSize: '0.8em' }}
                                  // onClick={(e) => {
                                  //   this.props.clickVOD(e, data.vod, data);
                                  // }}

                                  onClick={(e) => {
                                    this.props.clickDetail(e, data);
                                  }}
                                />
                              ) : null}
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* 행사타이틀 */}
                        <Grid container justifyContent="center" item xs={12}>
                          <div dangerouslySetInnerHTML={{ __html: tit }} />
                        </Grid>
                      </div>
                    </div>
                  );
                }
              })}
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(withWidth()(Scheduler));
